export default __webpack_public_path__ + "static/blob7-d291af11aa723e7055f55478540e77a3.svg";